import { render, staticRenderFns } from "./mould_equipment_product.vue?vue&type=template&id=03951720&scoped=true&"
import script from "./mould_equipment_product.vue?vue&type=script&lang=js&"
export * from "./mould_equipment_product.vue?vue&type=script&lang=js&"
import style0 from "./mould_equipment_product.vue?vue&type=style&index=0&id=03951720&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03951720",
  null
  
)

export default component.exports